import { generatePath } from 'react-router-dom';

import urls from '@routes/urls';

interface IInquiryUrlProps {
  isSupplementary: boolean;
  isResponded: boolean;
  inquiryId: number;
}

export const getInquiryDetailsUrl = (inquiryId: number) =>
  generatePath(urls.inquiryDetails, {
    inquiryId: inquiryId.toString(),
  });

export const getInquiryResponseUrl = (inquiryId: number) =>
  generatePath(urls.inquiryResponse, {
    inquiryId: inquiryId.toString(),
  });

export const getInquiryMedicationsDetailsUrl = (inquiryId: number) =>
  generatePath(urls.medicationsInquiryDetails, {
    inquiryId: inquiryId.toString(),
  });

export const getInquiryMedicationsResponseUrl = (inquiryId: number) =>
  generatePath(urls.medicationsInquiryResponse, {
    inquiryId: inquiryId.toString(),
  });

export const getInquiryUrl = ({
  isSupplementary,
  isResponded,
  inquiryId,
}: IInquiryUrlProps): string => {
  if (isSupplementary) {
    return isResponded ? getInquiryResponseUrl(inquiryId) : getInquiryDetailsUrl(inquiryId);
  }
  return isResponded
    ? getInquiryMedicationsResponseUrl(inquiryId)
    : getInquiryMedicationsDetailsUrl(inquiryId);
};
